/**
 * TanStack Query hooks for `offer-preview-api` (FS-237).
 * Query keys: ['offer-preview-api', 'keys'] for list, ['offer-preview-api', 'keys', id] for detail.
 * All writes invalidate the ['offer-preview-api'] root.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	createKey,
	listKeys,
	revokeKey,
	offerPreviewApiQueryKeys,
	type CreatePartnerKeyBody,
	type CreatePartnerKeyResponse,
	type ListPartnerKeysResponse,
	type RevokePartnerKeyResponse,
} from "./api";

export function useOfferPreviewApiList(): UseQueryResult<
	ListPartnerKeysResponse,
	Error
> {
	return useQuery({
		queryKey: offerPreviewApiQueryKeys.list(),
		queryFn: listKeys,
	});
}

export function useOfferPreviewApiCreate(): UseMutationResult<
	CreatePartnerKeyResponse,
	Error,
	CreatePartnerKeyBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: createKey,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: offerPreviewApiQueryKeys.all });
		},
	});
}

export function useOfferPreviewApiDelete(): UseMutationResult<
	RevokePartnerKeyResponse,
	Error,
	string
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: revokeKey,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: offerPreviewApiQueryKeys.all });
		},
	});
}
